import { useQuery } from "react-query";
import { fetchPlans } from "../services/api";

export const usePlans = () => useQuery([`plans`], () => fetchPlans());
